import { POSITIONS_V3_BLOTTER_PREFIX } from '@src/containers/Blotters/PositionsV3/tokens';
import { shouldRunBlotterTabsMigration } from '../../blotterTabsMigrationVersion';
import { migrateLegacyTabsIntoTradingBlotterPanels } from '../blotterTabsMigrationHelpers';
import type { AppConfigStateWithLegacyLayoutConfigs } from '../legacyLayoutConfigs.types';

/** Moves legacy positions tabs into positions blotter panel params. */
export function migratePositionsBlotterTabsToPanelParams(initialConfig: unknown) {
  const config = initialConfig as AppConfigStateWithLegacyLayoutConfigs;
  if (!shouldRunBlotterTabsMigration(config)) {
    return;
  }
  const legacyPositionsTabs = config.tabs?.[POSITIONS_V3_BLOTTER_PREFIX];
  if (legacyPositionsTabs == null) {
    return;
  }

  migrateLegacyTabsIntoTradingBlotterPanels(config, {
    legacyTabs: legacyPositionsTabs,
    blotterType: 'positionsBlotter',
  });
}
